module.exports = __webpack_public_path__ + "static/media/notification.af849915.svg";